/*global localStorage */
var _ = require('lodash');
var radio = require("react-pubsub-via-radio.js/radio");
var Balboa = require('ES/services/Balboa');
var esUtils = require('ES/utils/esUtils');
var RadioService = require("react-pubsub-via-radio.js/service");

var convertBalboa3toJS = function(Displaylists){
  if(_.has(Displaylists, 'speaker_shared') && _.has(Displaylists.speaker_shared, 'templatefiles')){
    Displaylists.speaker_shared.templatefiles = _.mapValues(Displaylists.speaker_shared.templatefiles, esUtils.StoredFile_Balboa3toJS);
  }
  return Displaylists;
};

var Displaylists_cache = null;

module.exports.init = function(){
  radio('invalidate_Displaylists_cache').subscribe(function(){
    Displaylists_cache = null;
  });

  RadioService('Displaylists_get', function(params, callback){
    if(Displaylists_cache){
      callback(null, Displaylists_cache);
      return;
    }
    var signature = localStorage.getItem('Displaylists_signature') !== null ? localStorage.getItem('Displaylists_signature') : '';
    Balboa.api('/authenticate/getdisplaylists', {
      signature: signature,
      clear_cache: _.get(params, ["clear_cache"], false)
    }, function(data){
      Displaylists_cache = convertBalboa3toJS(data.data);
      callback(null, Displaylists_cache);
    }, function(data){
      callback((data && data.message) || 'unknown cause');
      console.error('Displaylists_get', data);
    });
  }, function(){
    return 1;
  });
};



// WEBPACK FOOTER //
// ./src/services/Displaylists.js